import React, { useEffect, useState } from "react";
import { UserAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { writeUserDoc } from "../Firebase";

const Signin = () => {
  const { googleSignIn, user } = UserAuth();
  const navigate = useNavigate();

  const handleSignInOrUp = async () => {
    try {
      await googleSignIn();
    } catch (error) {
      console.log(error);
    }
  };

  // show dashboard if the user is logged in
  useEffect(() => {
    if (user != null) {
      navigate("/dashboard");
      writeUserDoc();
    } else {
      navigate("/");
    }
  }, [user]);

  return (
    <>
      <div className="background"></div>
      <button
        className="button_white_small"
        style={{ width: "250px" }}
        onClick={handleSignInOrUp}
      >
        Log in / Sign Up
      </button>
    </>
  );
};

export default Signin;
